import { MultipleSelect, MultipleSelectProps } from './MultipleSelect';
import { SimpleSelect, SimpleSelectProps } from './SimpleSelect';
import { useMemo, forwardRef } from 'react';

export type SelectProps<T> = (SimpleSelectProps<T> | MultipleSelectProps<T>) & { isMultiple?: boolean, onWhite?: boolean };

export const Select = forwardRef(<T extends any,>(
  props: Omit<SelectProps<T>, 'onSelect' | 'onRemove'>,
  ref: React.Ref<any>
) => {
  const Component = useMemo(() => {
    return props.isMultiple ? MultipleSelect : SimpleSelect;
  }, [props.isMultiple]);

  // @ts-ignore
  return <Component ref={ref} {...props} />;
});
